module.exports = __webpack_public_path__ + "img/ti6.90d90d18.png";